import React, { useState } from "react";
import Box from "@mui/material/Box";
import Avatar from "@mui/material/Avatar";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import IconButton from "@mui/material/IconButton";

import LanguageIcon from "@mui/icons-material/Language";
import CheckIcon from "@mui/icons-material/Check";
import { useTranslation } from "react-i18next";
import { LanguagesEnum } from "../../../types";

export const LangSelect = () => {
  const { i18n } = useTranslation();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box sx={{ display: "flex" }}>
      <Box sx={{ display: "flex", alignItems: "center", textAlign: "center" }}>
        <IconButton onClick={handleClick} size="small">
          <Avatar
            sx={{
              width: 40,
              height: 40,
              backgroundColor: "lightGrey",
            }}
          >
            <LanguageIcon fontSize="medium" />
          </Avatar>
        </IconButton>
      </Box>
      <Menu
        anchorEl={anchorEl}
        id="lang-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <MenuItem
          onClick={() => {
            i18n.changeLanguage(LanguagesEnum.EN);
          }}
        >
          <ListItemIcon>
            {i18n.language === LanguagesEnum.EN && (
              <CheckIcon fontSize="small" />
            )}
          </ListItemIcon>
          Eng
        </MenuItem>
        <MenuItem
          onClick={() => {
            i18n.changeLanguage(LanguagesEnum.RU);
          }}
        >
          <ListItemIcon>
            {i18n.language === LanguagesEnum.RU && (
              <CheckIcon fontSize="small" />
            )}
          </ListItemIcon>
          Рус
        </MenuItem>
      </Menu>
    </Box>
  );
};
